/** @format */

import React, { useEffect, useState, createRef } from "react";
import { useCookies } from "react-cookie";
// import { useKeycloak } from "@react-keycloak/ssr";
import { useRouter } from "next/router";
import ReCAPTCHA from "react-google-recaptcha";
// import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { Form, Input, Select, Row, Col, Button, message, Upload ,Checkbox} from "antd";
import { PlusOutlined,WhatsAppOutlined , PaperClipOutlined} from "@ant-design/icons";
import moment from "moment";
import { countryList } from "../../utils/getCountries";
import categories from "../../public/filestore/categories.json";
import { apiError, formFallout, formSubmit, formView, quoteSubmit } from "../../utils/GTMDataLayer";
import { generateRandomString } from "../../utils/generateRandomString";
import { logger } from "@goldenbird1/ui-logger-library";
import { accessToken } from "../../utils/accessToken";
// import { Qalara_RFQ_submitted} from "../../utils/moEngageEvents"
import { v4 as uuidv4 } from "uuid";

const { Option } = Select;

const SendQueryForm = (props) => {
  const recaptchaRef = React.createRef();
  function onChange(value) {
    // console.log("Captcha value:", value);
  }
  // const [token, setToken] = React.useState("");
  // const { executeRecaptcha } = useGoogleReCaptcha();
  // const clickHandler = async () => {
  //   if (!executeRecaptcha) {
  //     return;
  //   }

  //   const result = await executeRecaptcha("sendQuery");

  //   setToken(result);
  // };
  const [form] = Form.useForm();
  const router = useRouter();
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = useState([]);
  // const { keycloak } = useKeycloak();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [cookie, setCookie] = useCookies(["utm_source"]);
  const [whatsApp,setWhatsApp]= useState(props.initialValues.whatsappConsent === 'Yes' ? true : false);
  const [whatsAppNumber,setWhatsAppNumber] = useState(props.initialValues.whatsappNumber);
  const [selectedOption, setSelectedOption] = useState([]);
  const [selectedOther, setSelectedOther] = useState([])
  const [productCategories, setProductCategories] = useState([])
  const [selectedProductOption, setSelectedProductOption] = useState([]);

  // let token = "";
  // if(localStorage.getItem('kcAccessToken')){
  //   token = localStorage.getItem('kcAccessToken');
  // }
  
  let retryCount = 0;
  const { initialValues = {} } = props || {};

  const acceptedFileTypes = [
    "application/pdf",
    "application/msword",
    "application/vnd.ms-excel",
    "application/vnd.ms-powerpoint",
    "image/jpeg",
    "image/png",
  ];

  const typeOfCategories = categories.map((v, i) => {
    return (
      <Option key={i} value={v.key}>
        {v.value}
      </Option>
    );
  });

  const feildnameArray = [],
    gtmFormFunction = (feildname) => {
      try {
        if (!feildnameArray.includes(feildname)) {
          formFallout(feildname, "qalara rfq", "");
          feildnameArray.push(feildname);
        }
      } catch (err) {
        console.warn("datalayer form fallout error: " + err);
      }
    };

  useEffect(() => {
    let token = '';
    token = accessToken();
    if(localStorage.getItem('kcTokenSaved') && token){
      setIsAuthenticated(true);
    }
  }, []);

  useEffect(() => {
    try {
      formView("qalara rfq", "");
    } catch (err) {
      console.warn("datalayer form view error: " + err);
    }
  }, [props]);


  useEffect(() => {
    let buyerId = initialValues && initialValues.profileId ? initialValues.profileId : null;
    let url = process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL + "/master_data/v1/product-type"
    fetch(url,{
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          'trace-id' : uuidv4()
        },
      }
    )
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw (
            res.statusText || "Oops something went wrong. Please try again!"
          );
        }
      })
      .then((res) => {
        setProductCategories(res?.filter((value, index, self) => index === self.findIndex((t) => ( t.name === value.name))))
      })
      .catch((err) => {
        console.log(err.message || err, 5);
        logger("error", "Error from product-type api :" + url +"SendQueryForm " +err+ ': buyerId => '+buyerId, process.env.NEXT_PUBLIC_LOGGER_URL);
      });
  }, []);

  const beforeUpload = (file) => {
    const isJpgOrPng = acceptedFileTypes.includes(file.type);
    if (!isJpgOrPng) {
      message.error(
        "You can only upload JPG/PNG, PDF, MS-Excel & MS-PPT file!",
        5
      );
      return false;
    }
    const isLt2M = file.size <= 2 * 1024 * 1024;
    if (!isLt2M) {
      message.error("File size must smaller than 2MB!", 5);
      return false;
    }
    return isJpgOrPng && isLt2M;
  };

  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow.document.write(image.outerHTML);
  };

  const handleChange = (info) => {
    if (
      info.file.status === "done" ||
      info.file.status === "removed" ||
      info.file.status === "uploading"
    ) {
      let { fileList = [] } = info || {};
      let uploadedList = [];
      for (let file of fileList) {
        const isJpgOrPng = acceptedFileTypes.includes(file.type);
        const isLt2M = file.size <= 2 * 1024 * 1024;
        if (isJpgOrPng && isLt2M) {
          uploadedList.push(file);
        }
      }
      setFileList(uploadedList);
      return;
    }
  };

  const rfqCall = (data) => {
    let buyerId = initialValues && initialValues.profileId ? initialValues.profileId : null;
    let url = process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL + "/home/forms/v3/queries";;
    if(props.token && typeof props.token === 'string'){
      fetch(url, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + props.token,
          "trace-id": uuidv4(),
        },
      })
        .then((res) => {
          // console.log(res);
          if (res.ok) {
            // message.success('Your query has been sent successfully.', 5);
            form.resetFields();
            props.sendQueryCancel("success");
            formSubmit("qalara rfq", "");
            quoteSubmit();
          } else {
            apiError("rfqCall", res.statusText, "GET", "SendQueryForm.js");
            // message.error(res.statusText, 5);
            setErrors(
              errors.concat({
                atStage: "Error while sending",
                message: res.statusText,
              })
            );
            throw res;
          }
          setLoading(false);
        })
        .catch((err) => {
          let path = "";
          if (router.asPath === "/") {
            path = "homepage";
          }
          logger(
            "error",
            "Error from" +
              path +
              "RFQ " +
              err?.statusText +
              " data:" +
              JSON.stringify(data) +
              ": buyerId => " +
              buyerId,
            process.env.NEXT_PUBLIC_LOGGER_URL
          );
          apiError("rfqCall", err, "GET", "SendQueryForm.js");
          if (err.status === 401) {
            router.push("/signin");
          } else {
            if (retryCount < 3) {
              rfqCall(data);
            } else {
              message.error(err.message, 5);
              setErrors(errors.concat(err));
              setLoading(false);
            }
            retryCount++;
          }
        });
    } else {
      window.location.reload();
    }
  };

  const onFinishUrl = (values) => {
    let isAnonymousUser = true;
    if (initialValues && initialValues.profileId) {
      isAnonymousUser = false;
    } else {
      const recaptchaValue = recaptchaRef?.current?.getValue();
      if (!recaptchaValue && router.asPath !== '/explore/curatedbyus/') {
        console.log("Invalid Recaptcha", router.asPath);
        return;
      }
    }

    var data = {
      profileId: (initialValues && initialValues.profileId) || "anonymous",
      profileType: (initialValues && initialValues.profileType) || "anonymous",
      isAnonymousUser: isAnonymousUser,
      questions: values.requirementDetails,
      quantityRequired: values.quantity,
      emailId: values.emailId,
      destinationCountry: values.destinationCountry,
      mobileNo: values.mobileNo,
      rfqType: "QALARA",
      buyerId: props.userId && props.userId.split("::")[1],
      consent : whatsApp ? "Yes" : "No",
      // communicationNumber : whatsAppNumber
    };

    /* read and pass utm source from cookie  */
    if (cookie.utm_source) {
      let cookieVal = cookie.utm_source;

      data.utm = cookieVal.utm_source;
      data.utmCampaign = cookieVal.utm_campaign;
      data.utmMedium = cookieVal.utm_medium;
      data.utmTerm = cookieVal.utmTerm;
      data.adGroupId = cookieVal.adGroupId;
      data.keyword = cookieVal.keyword;
      data.utmDevice = cookieVal && cookieVal.utm_device ? cookieVal.utm_device : ''
    }
    /* --- */

    if (isAuthenticated) {
      // data.profileId = keycloak.subject;
      data.profileId = props.initialValues?.kcIdentityId || null;
      data.isAnonymousUser = false;
    }
    // console.log('Received values of form: ', values);
    if (values.upload && values.upload.fileList) {
      data.attachments = values.upload.fileList.map((fileobj) => {
        return fileobj.response;
      });
    }

    // console.log(data);
    setLoading(true);
    let buyerId = initialValues && initialValues.profileId ? initialValues.profileId : null;
    fetch(
      "https://ipapi.co/json/?key=JWzTw2TRf981G4oH1uZB5EwoM7iuNetMOB70dIhbnTAaO121To",
      {
        method: "GET",
      }
    )
      .then((response) => response.json())
      .then((result) => {
        let { ip = "", country = "" } = result;
        data.fromIP = ip;
        data.ipCountry = country;
        rfqCall(data);
      })
      .catch((err) => {
        apiError('onFinish', err, 'GET', 'SendQueryForm.js');
        logger("error", "Error from RFQ ipapi " +err + ': buyerId => '+buyerId, process.env.NEXT_PUBLIC_LOGGER_URL);
        data.fromIP = "";
        data.ipCountry = "";
        rfqCall(data);
      });
      // Qalara_RFQ_submitted({Form_submitted:true,pagetype:"HomePage"})
  };

  const onFinish = (values) => {
    if(selectedOption?.includes("other")){
      values.customizationRequirements = [selectedOther];
    }
    let isAnonymousUser = true;
    if (initialValues && initialValues.profileId) {
      isAnonymousUser = false;
    } else {
      const recaptchaValue = recaptchaRef?.current?.getValue();
      if (!recaptchaValue && router.asPath !== '/explore/curatedbyus/') {
        console.log("Invalid Recaptcha", router.asPath);
        return;
      }
    }

    var data = {
      profileId: (initialValues && initialValues.profileId) || "anonymous",
      profileType: (initialValues && initialValues.profileType) || "anonymous",
      isAnonymousUser: isAnonymousUser,
      queryCategory: values.category,
      questions: values.requirementDetails,
      productCategoryComment: values.productCategory,
      customizationRequirmentsComment: values.customizationRequirements,
      quantityRequired: values.quantity,
      targetUnitPrice: values.pricePerItem,
      targetDeliveryDate: values.deliveryDate,
      requesterName: values.requesterName,
      companyName: props.initialValues.companyName,
      emailId: values.emailId,
      country: values.destinationCountry,
      destinationCountry: values.destinationCountry,
      zipcode: values.zipcode,
      deliverylocationType: values.deliverylocationType,
      mobileNo: values.mobileNo,
      preferedCurrency: values.preferedCurrency,
      rfqType: "QALARA",
      buyerId: props.userId && props.userId.split("::")[1],
      consent : whatsApp ? "Yes" : "No",
      communicationNumber : whatsAppNumber
    };

    /* read and pass utm source from cookie  */
    if (cookie.utm_source) {
      let cookieVal = cookie.utm_source;

      data.utm = cookieVal.utm_source;
      data.utmCampaign = cookieVal.utm_campaign;
      data.utmMedium = cookieVal.utm_medium;
      data.utmTerm = cookieVal.utmTerm;
      data.adGroupId = cookieVal.adGroupId;
      data.keyword = cookieVal.keyword;
      data.utmDevice = cookieVal && cookieVal.utm_device ? cookieVal.utm_device : ''
    }
    /* --- */

    if (isAuthenticated) {
      // data.profileId = keycloak.subject;
      data.profileId = props.initialValues?.kcIdentityId || null;
      data.isAnonymousUser = false;
    }
    // console.log('Received values of form: ', values);
    if (values.upload && values.upload.fileList) {
      data.attachments = values.upload.fileList.map((fileobj) => {
        return fileobj.response;
      });
    }

    // console.log(data);
    setLoading(true);
    let buyerId = initialValues && initialValues.profileId ? initialValues.profileId : null;
    fetch(
      "https://ipapi.co/json/?key=JWzTw2TRf981G4oH1uZB5EwoM7iuNetMOB70dIhbnTAaO121To",
      {
        method: "GET",
      }
    )
      .then((response) => response.json())
      .then((result) => {
        let { ip = "", country = "" } = result;
        data.fromIP = ip;
        data.ipCountry = country;
        rfqCall(data);
      })
      .catch((err) => {
        apiError('onFinish', err, 'GET', 'SendQueryForm.js');
        logger("error", "Error from RFQ ipapi " +err + ': buyerId => '+buyerId, process.env.NEXT_PUBLIC_LOGGER_URL);
        data.fromIP = "";
        data.ipCountry = "";
        rfqCall(data);
      });
      // Qalara_RFQ_submitted({Form_submitted:true,pagetype:"HomePage"})
  };

  const disabledDate = (current) => {
    // Can not select days before today and today
    return current && current < moment().endOf("day");
  };

  let assetUrl =
    process.env.NEXT_PUBLIC_REACT_APP_API_ASSETS_URL +
    "/assets?sourceService=forms";

  if (initialValues && initialValues.profileId) {
    assetUrl =
      process.env.NEXT_PUBLIC_REACT_APP_API_ASSETS_URL +
      "/assets?sourceService=forms&userId=" +
      initialValues.profileId;
  }

  const updateWhatsappNumber = e =>{
    let {value = ""} = e.target || {}
    value !== null && setWhatsAppNumber(value)
  }

  return (
    <Row id="send-query-form">
      <Col span={props.buyerDetails || props.sellerDetails ? 8 : 0}></Col>
      <Col
        span={props.buyerDetails || props.sellerDetails ? 16 : 24}
        style={{ marginBottom: 0, padddinBoBottem: 0 }}
        className="register"
      >
        <Row justify="center">
          <Col span={20}>
            <p className="heading">Sourcing request</p>
            <p className="paragraph qa-mar-btm-1">
            Use this form if you have a specific product requirement or can't find
            what you are looking for! 


            </p>
          </Col>
        </Row>
        { props?.urlForm ? 
          <Form
          form={form}
          name="send_query_form"
          initialValues={initialValues}
          onFinish={onFinishUrl}
          scrollToFirstError
          autoComplete="dontshow"> 
          <Row justify="center">
           <Col span={20}>
           <div className="label-paragraph qa-lh">
                Please describe the type of products, services , customisation requirement, or what you're
                looking for*
              </div>
              <Form.Item
                name="requirementDetails"
                style={{ marginBottom: "1em" }}
                rules={[
                  {
                    required: true,
                    message: "Please enter your requirement.",
                  },
                  {
                    min: 10,
                    max: 500,
                    message: "Please enter message within 10-500 characters.",
                  },
                ]}
              >
                <Input.TextArea
                  onFocus={() => gtmFormFunction("requirement details")}
                  value={"value"}
                  autoSize={{ minRows: 3, maxRows: 4 }}
                  autoComplete="dontshow"
                  id={`requirementDetails_${generateRandomString()}`}
                />
              </Form.Item>
              <div className="label-paragraph qa-lh">
                Please give an indication of quantities required per product (to
                match the right price and supplier)*
              </div>
              <Form.Item
                name="quantity"
                style={{ marginBottom: "0" }}
                rules={[
                  {
                    type: "string",
                    message: "The input is not valid!",
                  },
                  {
                    required: true,
                    message: "Please enter quantity range.",
                  },
                  {
                    min: 1,
                    max: 50,
                    message: "Length should be 1-50 characters!",
                  },
                ]}
              >
                <Select 
                 placeholder="Select quantity"
                 style={{ marginBottom: "1em" }}
                 onFocus={() => gtmFormFunction("quantity")}
                 autoComplete="dontshow"
                 showSearch
                 getPopupContainer={(trigger) => trigger.parentElement}
                 id={`quantity_${generateRandomString()}`}>
                  <Option value="50-100perSKU">50 - 100 per SKU</Option>
                  <Option value='100-300perSKU'>100 - 300 per SKU </Option>
                  <Option value='300-500perSKU'>300 - 500 per SKU</Option>
                  <Option value='500-1000perSKU'>500 - 1000 per SKU</Option>
                  <Option value='1000-5000perSKU'>1000 - 5000 per SKU</Option>
                  <Option value='5000+perSKU'>Above 5000 per SKU</Option>

                </Select>
              </Form.Item>
              <Col style={{display : "flex",columnGap : '10px', marginBottom : "-30px"}}>
              <div className="label-paragraph qa-lh">
                Attach reference images of designs, if available.
              </div>
              <Form.Item
                name="upload"
                style={{marginTop:"-2px"}}
              >
                <Upload
                  name="files"
                  className="attach-upload"
                  fileList={fileList}
                  action={assetUrl}
                  headers={{
                    Authorization: "Bearer " + props.token,
                  }}
                  beforeUpload={beforeUpload}
                  onPreview={onPreview}
                  onChange={handleChange}
                  multiple
                >
                  {fileList?.length >= 10 ? null:<PaperClipOutlined/>}
                </Upload>
              </Form.Item>
              </Col>
              <Col className="max-size-upload-col">
  <span className="max-size-upload">
    Max size per attachment: 2MB
  </span><br/>
</Col>
<span className="label-paragraph desktop-margin-top">Destination Country*</span>

              <Form.Item
                name="destinationCountry"
                style={{ marginBottom: "1em", cursor: "pointer" }}
                rules={[
                  { required: true, message: "Please select your country." },
                ]}
              >
                <Select
                  placeholder="Select country"
                  showSearch
                  getPopupContainer={(trigger) => trigger.parentElement}
                  id={`country_${generateRandomString()}`}
                  autoComplete="dontshow"
                  filterOption={(input, option) =>
                    option.props.value
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0 ||
                    option.props.label
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {countryList}
                </Select>
              </Form.Item>
              <span className="label-paragraph">Email address*</span>
              <Form.Item
                name="emailId"
                style={{ marginBottom: "1em" }}
                rules={[
                  {
                    type: "email",
                    message: "Please enter a correct email address.",
                  },
                  {
                    required: true,
                    message: "Please enter your email address.",
                  },
                ]}
              >
                <Input
                  onFocus={() => gtmFormFunction("email")}
                  autoComplete="dontshow"
                  id={`emailId_${generateRandomString()}`}
                  // placeholder="E-mail ID"
                />
              </Form.Item>

              <span className="label-paragraph">Phone number*</span>
              <Form.Item
                name="mobileNo"
                style={{ marginBottom: "1em" }}
                rules={[
                  {
                    pattern: new RegExp("^[0-9]{6,15}$"),
                    message: "Wrong format!",
                  },
                  {
                    required: true,
                    message: "Please enter your phone number.",
                  },
                ]}
              >
                <Input
                  onFocus={() => gtmFormFunction("mobile")}
                  autoComplete="dontshow"
                  id={`mobileNo_${generateRandomString()}`}
                  // placeholder="Phone Number"
                />
              </Form.Item>
              {!isAuthenticated && (
                <Form.Item
                  className="agreement"
                  name="recaptcha"
                  style={{ marginBottom: "1em" }}
                  valuePropName="recaptcha"
                  rules={[
                    {
                      validator: (_, value) =>
                        value
                          ? Promise.resolve()
                          : Promise.reject("Please accept the recaptcha."),
                    },
                  ]}
                >
                  <ReCAPTCHA
                    sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
                    ref={recaptchaRef}
                    onChange={onChange}
                  />
                </Form.Item>
              )}
              <Form.Item className="tnc_wrap"
                          name="agreement"
                          valuePropName="checked"
                          rules={[
                            {
                              required: true,
                              message: "Please accept T&C",
                              validator: (_, value) =>
                                value
                                  ? Promise.resolve()
                                  : Promise.reject("Please accept T&C."),
                            },
                ]}>
                  <Checkbox 
                    className="check-box-tnc"
                    onChange={(e) => {
                    let { checked = "" } = e.target || {};
                     setWhatsApp(checked);
                    }}   
                    checked={whatsApp} 
                  > Allow Qalara to share non promotional WhatsApp notification, *T&C applicable</Checkbox>
              </Form.Item>
           </Col>
          </Row>
          <Form.Item  style={{ margin: "0"}} className="submit">
            <Button
              type="primary"
              loading={loading}
              disabled={loading}
              htmlType="submit"
              className="submit-button" 
            >
              Submit
            </Button>
          </Form.Item>
          </Form>
            :
          <Form
          form={form}
          name="send_query_form"
          initialValues={initialValues}
          onFinish={onFinish}
          scrollToFirstError
          autoComplete="dontshow"
        >
          <Row justify="center">
            <Col span={20}>
              <div className="label-paragraph qa-lh">
                Tell us about your brand / business to help us find the right
                match.
              </div>
              <Form.Item
                name="category"
                style={{ marginBottom: "1em" }}
                className="modified-selector"
                // label='I am looking for'
                rules={[
                  {
                    required: true,
                    message: "Please share some details.",
                  },
                  {
                    min: 10,
                    max: 500,
                    message: "Please enter message within 10-500 characters.",
                  },
                ]}
              >
                <Input.TextArea
                  onFocus={() => gtmFormFunction("category")}
                  value={"value"}
                  autoSize={{ minRows: 2, maxRows: 4 }}
                  autoComplete="dontshow"
                  id={`category_${generateRandomString()}`}
                />
              </Form.Item>
              <div className="label-paragraph qa-lh">
                Please describe the type of products, or services, you're
                looking for.
              </div>
              <Form.Item
                name="requirementDetails"
                style={{ marginBottom: "1em" }}
                rules={[
                  {
                    required: true,
                    message: "Please enter your requirement.",
                  },
                  {
                    min: 10,
                    max: 500,
                    message: "Please enter message within 10-500 characters.",
                  },
                ]}
              >
                <Input.TextArea
                  onFocus={() => gtmFormFunction("requirement details")}
                  value={"value"}
                  autoSize={{ minRows: 2, maxRows: 4 }}
                  autoComplete="dontshow"
                  id={`requirementDetails_${generateRandomString()}`}
                />
              </Form.Item>
              <div className="label-paragraph">Product category</div>
              <br />
              <Form.Item
                name="productCategory"
                rules={[
                  { required: true, message: "Please select product category." },
                ]}
              >
               <Select
               mode="multiple"
               showArrow
               autoComplete="dontshow"
               value={selectedProductOption}
               placeholder="Select product category"
               onChange={setSelectedProductOption}
               className="select-multiple-product"
               >
                {productCategories && productCategories?.map((category) => {
                  return (
                    <Select.Option value={category.name}>{category.name}</Select.Option>
                  )
                })}
               </Select>
              </Form.Item>

              <div className="label-paragraph">If you have any customization requirements, please select them from the options below.</div>
              <br />
              <Form.Item
                name="customizationRequirements"
                rules={[
                  { required: true, message: "Please select customization requirements." },
                ]}
              >
               <Select
               mode="multiple"
               showArrow
               value={selectedOption}
               autoComplete="dontshow"
               placeholder="Select customization type"
               onChange={setSelectedOption}
               className="select-multiple-product"
               >
                <Select.Option disabled={selectedOption?.includes("other")} value="branding">Branding</Select.Option>
                <Select.Option disabled={selectedOption?.includes("other")} value="color">Color</Select.Option>
                <Select.Option disabled={selectedOption?.includes("other")} value="size">Size</Select.Option>
                <Select.Option disabled={selectedOption?.includes("other")} value="design">Design</Select.Option>
                <Select.Option disabled={selectedOption?.includes("other")} value="material">Material</Select.Option>
                <Select.Option  disabled={!selectedOption?.includes("other") && (selectedOption?.length !== 0)} value="other">Other</Select.Option>
               </Select>
              </Form.Item>
              {selectedOption?.includes('other') ?
              <Form.Item
                name="additionalRequirement"
                rules={[
                  {
                    required: true,
                    message: "Please enter your requirement.",
                  },
                  {
                    min: 10,
                    max: 500,
                    message: "Please enter message within 10-500 characters.",
                  },
                ]}
              >
                <Input.TextArea
                  onFocus={() => gtmFormFunction("additional requirement")}
                  value={"value"}
                  autoSize={{ minRows: 4, maxRows: 6 }}
                  autoComplete="dontshow"
                  placeholder="Specify any additional needs here"
                  onChange={(e) => {setSelectedOther(e.target.value)}}
                />
              </Form.Item> : ""}
              <div className="label-paragraph qa-lh ref-photos">
                Attach reference images of designs, if available
              </div>
              <br />
              <Form.Item
                name="upload"
                style={{ marginBottom: "1em" }}
                extra={
                  <span className="qa-mar-top-1 max-size-upload">
                    Max size per attachment: 2MB
                  </span>
                }
              >
                <Upload
                  name="files"
                  listType="picture-card"
                  fileList={fileList}
                  action={assetUrl}
                  headers={{
                    Authorization: "Bearer " + props.token,
                  }}
                  // className="avatar-uploader"
                  beforeUpload={beforeUpload}
                  onPreview={onPreview}
                  onChange={handleChange}
                  multiple
                >
                  {fileList.length >= 10 ? null : <PlusOutlined />}
                </Upload>
              </Form.Item>
              <div className="label-paragraph qa-lh">
                Please give an indication of quantities required per product (to
                match the right price and supplier)*
              </div>
              <Form.Item
                name="quantity"
                style={{ marginBottom: "0" }}
                rules={[
                  {
                    type: "string",
                    message: "The input is not valid!",
                  },
                  {
                    required: true,
                    message: "Please enter quantity range.",
                  },
                  {
                    min: 1,
                    max: 50,
                    message: "Length should be 1-50 characters!",
                  },
                ]}
              >
                <Select 
                 placeholder="Select quantity"
                 onFocus={() => gtmFormFunction("quantity")}
                 autoComplete="dontshow"
                 showSearch
                 getPopupContainer={(trigger) => trigger.parentElement}
                 id={`quantity_${generateRandomString()}`}>
                  <Option value="50-100perSKU">50 - 100 per SKU</Option>
                  <Option value='100-300perSKU'>100 - 300 per SKU </Option>
                  <Option value='300-500perSKU'>300 - 500 per SKU</Option>
                  <Option value='500-1000perSKU'>500 - 1000 per SKU</Option>
                  <Option value='1000-5000perSKU'>1000 - 5000 per SKU</Option>
                  <Option value='5000+perSKU'>Above 5000 per SKU</Option>

                </Select>
              </Form.Item>
              <div><span className=" max-size-upload">
                For lower quantities, we recommend you select products from our existing catalog
                  </span></div><br />
              
              <span className="label-paragraph">Destination Country*</span>
              <Form.Item
                name="destinationCountry"
                style={{ marginBottom: "1em", cursor: "pointer" }}
                rules={[
                  { required: true, message: "Please select your country." },
                ]}
              >
                <Select
                  placeholder="Select country"
                  showSearch
                  getPopupContainer={(trigger) => trigger.parentElement}
                  id={`country_${generateRandomString()}`}
                  autoComplete="dontshow"
                  filterOption={(input, option) =>
                    option.props.value
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0 ||
                    option.props.label
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {countryList}
                </Select>
              </Form.Item>
              <span className="label-paragraph">Delivery location type</span>
              <Form.Item
                name="deliverylocationType"
                style={{ marginBottom: "1em" }}
              >
                <Select
                  placeholder="Select location type"
                  onFocus={() => gtmFormFunction("delivery location")}
                  showSearch
                  autoComplete="dontshow"
                  id={`deliverylocationType_${generateRandomString()}`}
                  getPopupContainer={(trigger) => trigger.parentElement}
                >
                  <Option value="home">Home</Option>
                  <Option value="store">Store</Option>
                  <Option value="office">Office</Option>
                  <Option value="warehouse">Warehouse</Option>
                  <Option value="amazonWarehouse">Amazon Warehouse</Option>
                  <Option value="others">Others</Option>
                  );
                </Select>
              </Form.Item>
              <span className="label-paragraph">
              Destination Pin/ Postal/ Zip Code*
              </span>
              <Form.Item
                name="zipcode"
                style={{ marginBottom: "1em" }}
                rules={[
                  {
                    required: true,
                    message: "Please enter your zipcode.",
                    whitespace: true,
                  },
                ]}
              >
                <Input
                  onFocus={() => gtmFormFunction("zip code")}
                  autoComplete="dontshow"
                  id={`zipcode_${generateRandomString()}`}
                />
              </Form.Item>
              <div className="label-heading" id="user-details">
                Please share your details so we can respond:
              </div>

              <div
                className="label-paragraph info-safe"
                style={{ marginBottom: "0.5em", lineHeight: "100%" }}
              >
                Your information is safe with us.
              </div>
              <br />
              {/* <p style={{ fontWeight: 'bold', fontSize: '15px', marginBottom: '0.5em' }}>From,</p> */}
              <span className="label-paragraph">Your name*</span>
              <Form.Item
                name="requesterName"
                style={{ marginBottom: "1em" }}
                rules={[
                  { required: true, message: "Please enter your name." },
                  {
                    min: 3,
                    max: 50,
                    message: "Length should be 3-50 characters!",
                  },
                ]}
              >
                <Input
                  onFocus={() => gtmFormFunction("name")}
                  autoComplete="dontshow"
                  id={`requesterName_${generateRandomString()}`}
                  // placeholder="Your Name"
                />
              </Form.Item>
              <span className="label-paragraph">Email address*</span>
              <Form.Item
                name="emailId"
                style={{ marginBottom: "1em" }}
                rules={[
                  {
                    type: "email",
                    message: "Please enter a correct email address.",
                  },
                  {
                    required: true,
                    message: "Please enter your email address.",
                  },
                ]}
              >
                <Input
                  onFocus={() => gtmFormFunction("email")}
                  autoComplete="dontshow"
                  id={`emailId_${generateRandomString()}`}
                  // placeholder="E-mail ID"
                />
              </Form.Item>

              <span className="label-paragraph">Phone number</span>
              <Form.Item
                name="mobileNo"
                style={{ marginBottom: "1em" }}
                rules={[
                  {
                    pattern: new RegExp("^[0-9]{6,15}$"),
                    message: "Wrong format!",
                  },
                ]}
              >
                <Input
                  onFocus={() => gtmFormFunction("mobile")}
                  autoComplete="dontshow"
                  id={`mobileNo_${generateRandomString()}`}
                  // placeholder="Phone Number"
                />
              </Form.Item>
              <span className="label-paragraph">
                Preferred currency for quotation
              </span>
              <Form.Item
                name="preferedCurrency"
                style={{ marginBottom: "1em" }}
                rules={[
                  {
                    required: true,
                    message:
                      "Please select your preferred currency for quotation.",
                  },
                ]}
              >
                <Select
                  placeholder="Select preferred currency"
                  onFocus={() => gtmFormFunction("preferred currency")}
                  showSearch
                  autoComplete="dontshow"
                  id={`preferedCurrency_${generateRandomString()}`}
                  getPopupContainer={(trigger) => trigger.parentElement}
                >
                  <Option value="USD">USD</Option>
                  <Option value="AUD">AUD</Option>
                  <Option value="EUR">EUR</Option>
                  <Option value="GBP">GBP</Option>
                  );
                </Select>
              </Form.Item>
              {!isAuthenticated && (
                <Form.Item
                  className="agreement"
                  name="recaptcha"
                  style={{ marginBottom: "1em" }}
                  valuePropName="recaptcha"
                  rules={[
                    {
                      validator: (_, value) =>
                        value
                          ? Promise.resolve()
                          : Promise.reject("Please accept the recaptcha."),
                    },
                  ]}
                >
                  <ReCAPTCHA
                    sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
                    ref={recaptchaRef}
                    onChange={onChange}
                  />
                </Form.Item>
              )}
            </Col>
          </Row>
          <Form.Item style={{ margin: "0" }} className="submit">
            <Button
              type="primary"
              loading={loading}
              disabled={loading}
              htmlType="submit"
              className="submit-button"
              

            >
              Submit
            </Button>
          </Form.Item>
          </Form>
        }
      </Col>
    </Row>
  );
};

export default SendQueryForm;
